import { createTheme } from '@mui/material/styles';
import { C, F } from '../styles/tokens';

const theme = createTheme({
  palette: {
    primary: {
      main:  C.blue,
      dark:  C.blueDark,
      light: C.blueLight,
    },
    secondary: {
      main: C.amber,
      dark: C.amberDark,
    },
    background: {
      default: C.bg,
      paper:   C.white,
    },
    text: {
      primary:   C.text,
      secondary: C.textMid,
    },
  },
  typography: {
    fontFamily: F.heading,
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontFamily: F.body },
    body2: { fontFamily: F.body },
    caption: { fontFamily: F.body },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily:    F.heading,
          fontWeight:    700,
          borderRadius:  '10px',
          textTransform: 'none',
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', size: 'small' },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontFamily: F.body, fontWeight: 500 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily:  F.body,
          fontSize:    13,
          borderRadius: 8,
          padding:     '8px 12px',
        },
      },
    },
  },
});

export default theme;
